import React from 'react';
import styles from './PrimaryButton.module.css';

function PrimaryButton({ children, onClick, className, href = '#' }) {
  return (
    <a 
      href={href}
      className={`${styles.primaryButton} ${className || ''}`}
      onClick={onClick}
    >
      {children}
    </a>
  );
}

export default PrimaryButton;
